<template>
<svg viewBox="0 0 48 48" :fill="useCurrentColor ? 'currentColor' : 'currentColor'" :class="[`${prefix}-icon`, `${prefix}-icon-toggle-calendar-view`]" width="1em" height="1em" v-bind="$attrs"><path fill-rule="evenodd" clip-rule="evenodd" d="M14.718 4c.446 0 .607.046.77.134.163.087.291.215.378.378.088.163.134.324.134.77V7h16V5.282c0-.446.046-.607.134-.77a.908.908 0 01.378-.378c.163-.088.324-.134.77-.134h1.436c.446 0 .607.046.77.134.163.087.291.215.378.378.088.163.134.324.134.77V7h6a2 2 0 012 2v34a2 2 0 01-2 2H6a2 2 0 01-2-2V9a2 2 0 012-2h6V5.282c0-.446.046-.607.134-.77a.908.908 0 01.378-.378c.162-.088.324-.134.77-.134h1.436zM12 11H8v30h32V11h-4v1.718c0 .446-.046.607-.134.77a.908.908 0 01-.378.378c-.163.088-.324.134-.77.134h-1.436c-.446 0-.607-.046-.77-.134a.908.908 0 01-.378-.378c-.088-.162-.134-.324-.134-.77V11H16v1.718c0 .446-.046.607-.134.77a.908.908 0 01-.378.378c-.162.088-.324.134-.77.134h-1.436c-.446 0-.607-.046-.77-.134a.908.908 0 01-.378-.378c-.088-.162-.134-.324-.134-.77V11zm22 17a1 1 0 011 1v2a1 1 0 01-1 1H23V34.9a1 1 0 01-1.591.806l-5.816-4.265.007-.01-2.178-1.631A1 1 0 0114.02 28H34zm-8-10.9a1 1 0 01.592.194l5.406 3.97-.006.012 2.603 1.92A1 1 0 0134.002 25H14a1 1 0 01-1-1v-2a1 1 0 011-1h10.999L25 18.1a1 1 0 011-1z"/></svg>
</template>
<script>

export default {
  name: 'IconToggleCalendarView',
  props: {
    prefix: {
        type: String,
        default: 'm',
    },
    useCurrentColor: {
        type: Boolean,
        default: false,
    },
  },
};
</script>
